import { useApiClient } from '@/composables/useApiClient'
import * as branchService from '@/service/branch'
import * as productService from '@/service/product'
import { BranchReserveMode } from '@/view-models/branch'
import { BranchFaqSource } from '@/types/api'

export const state = () => ({
  branch: {},
  nearby: [],
  branchesInfo: { branches: [], totalCount: 0 },
  products: [],
  commentTagsList: [],
  faqList: [],
  faqSource: '',
  productCount: 0,
  selectedProductName: '',
  selectedHeadcount: 0,
  selectedStartTime: '',
  selectedEndTime: '',
  selectedProductIsCrossDay: false,
})

export const getters = {
  branch: state => state.branch,
  getMerchantBranches:
    state =>
    (branchTypes = []) =>
      state.branch.merchant_branches?.filter(merchantBranch => branchTypes.includes(+merchantBranch.type)) || [],
  nearby: state => state.nearby,
  branchesInfo: state => state.branchesInfo,
  products: state => state.products,
  productsForFunBook: state => state.products?.map(p => ({ ...p, product_name: p.fb_product_name || p.product_name })) || [],
  productsForFunNow: state => state.products?.map(p => ({ ...p, is_paid_onsite: false })) || [],
  commentTagsList: state => state.commentTagsList,
  faqList: state => state.faqList,
  isPaaSource: state => state.faqSource === BranchFaqSource.PAA,
  productCount: state => state.productCount,
  isFunBookV2: state => +state.branch.funbook_ver === 2,
  isTimeFirst: state => state.branch.reserve_mode === BranchReserveMode.TimeFirst,
  selectedBookingPayload: state => ({
    productName: state.selectedProductName,
    headCount: state.selectedHeadcount,
    startTime: state.selectedStartTime,
    endTime: state.selectedEndTime,
    isCrossDay: state.selectedProductIsCrossDay,
  }),
}

export const actions = {
  async getBranch({ commit }, { bid, lat, lng } = {}) {
    const url = `/pub/branch/${bid}`
    const hasGeolocation = lat !== undefined && lng !== undefined
    const config = hasGeolocation ? { params: { lat, lng } } : undefined
    const res = await useApiClient().$get(url, config)

    if (res.code === 0) {
      commit('SET_BRANCH', res.data)
      return res.data
    }
  },
  async getBranchList({ commit }, params) {
    const res = await branchService.getBranchList(useApiClient(), params)
    const branches = res.data.filter(branch => branch.onboard !== 0)
    commit('SET_BRANCHES_INFO', { branches, totalCount: res.total_count })
  },
  async getBranchNearby({ commit }, bid) {
    const url = `/pub/branch/${bid}/nearby-branches`
    const res = await useApiClient().$get(url)
    if (res.code === 0) {
      commit('SET_BRANCH_NEARBY', res.data)
    }
  },
  async getBranchProducts({ commit }, { bid, query = {} }) {
    const res = await productService.getBranchProducts(useApiClient(), bid, query)
    if (res.code !== 0) {
      return
    }
    const productsOfBranch = res.data
    commit('SET_PRODUCTS', productsOfBranch)
    commit('SET_PRODUCT_COUNT', res.total_count)
  },
  async getBookingEngineBranchProducts({ commit }, { bid, query = {} }) {
    const apiPath = `/branch/${bid}/products`
    const res = await useApiClient().$get(apiPath, { params: query, platform: 'FunBook' })
    if (res.code === 0) {
      const products = res.data.products
      commit('SET_PRODUCTS', products)
      commit('SET_PRODUCT_COUNT', res.total_count || 1)
    }
  },
  async getBranchFAQ({ commit }, { bid }) {
    commit('SET_FAQ_LIST', [])
    commit('SET_FAQ_SOURCE', '')
    try {
      const res = await branchService.getBranchPAA(useApiClient(), bid)
      if (res.code === 0) {
        commit('SET_FAQ_LIST', res.data.list)
        commit('SET_FAQ_SOURCE', res.data.source)
      }
    } catch {
      // PAA API 失敗時靜默處理，不影響頁面載入
    }
  },
  getBranchCommentTagList({ commit }, bid) {
    if (bid) {
      const url = `/pub/branch/${bid}/review-tags-count`
      useApiClient()
        .$get(url)
        .then(res => {
          if (res.code === 0) {
            commit('SET_BRANCH_COMMENT_TAGS_LIST', res.data)
          }
        })
    }
  },
  resetSelectedPayload({ commit }) {
    commit('SET_SELECTED_PRODUCT_NAME', '')
    commit('SET_SELECTED_HEADCOUNT', 0)
    commit('SET_SELECTED_START_TIME', '')
    commit('SET_SELECTED_END_TIME', '')
    commit('SET_SELECTED_PRODUCT_IS_CROSS_DAY', false)
  },
}

export const mutations = {
  SET_BRANCH(state, payload) {
    state.branch = payload
  },
  SET_BRANCHES_INFO(state, { branches, totalCount }) {
    state.branchesInfo = { branches, totalCount }
  },
  SET_BRANCH_NEARBY(state, payload) {
    state.nearby = payload
  },
  SET_PRODUCTS(state, payload) {
    state.products = payload
  },
  SET_BRANCH_COMMENT_TAGS_LIST(state, commentTagList) {
    state.commentTagsList = commentTagList.tags
  },
  SET_FAQ_LIST(state, faqList = []) {
    state.faqList = faqList
  },
  SET_FAQ_SOURCE(state, source = '') {
    state.faqSource = source
  },
  SET_PRODUCT_COUNT(state, count) {
    state.productCount = count
  },
  SET_SELECTED_PRODUCT_NAME(state, name) {
    state.selectedProductName = name
  },
  SET_SELECTED_HEADCOUNT(state, headcount) {
    state.selectedHeadcount = headcount
  },
  SET_SELECTED_START_TIME(state, startTime) {
    state.selectedStartTime = startTime
  },
  SET_SELECTED_END_TIME(state, endTime) {
    state.selectedEndTime = endTime
  },
  SET_SELECTED_PRODUCT_IS_CROSS_DAY(state, isCrossDay) {
    state.selectedProductIsCrossDay = isCrossDay
  },
}
